import FeatureKeys from "global/constants/FeatureKeys";
import {
  allOf,
  canSendRequests,
  canViewRenewables,
  canViewRequests,
  hasSideNav,
} from "../predicates";
import type { TourStepConfig } from "../../types/tour.types";

export const dashboardSteps: TourStepConfig[] = [
  {
    id: "shell-create-request",
    target: "shell.createRequest",
    title: "Create a request from anywhere",
    content: (ctx) =>
      ctx.hasFeature(FeatureKeys.ENVELOPE_BULK_SEND)
        ? "This button follows you across every page. Sign a document yourself, send it to others, or bulk send one document to a whole list of recipients."
        : "This button follows you across every page. Sign a document yourself, or send it to others for signature.",
    placement: "right",
    when: allOf(hasSideNav, canSendRequests),
  },
  {
    id: "dashboard-send",
    target: "dashboard.dropzone",
    title: "Upload a document to start",
    content:
      "Drop a file here and the request builder opens with it. You'll add recipients and place signature fields from there.",
    placement: "bottom",
    when: canSendRequests,
  },
  {
    id: "dashboard-activity",
    target: "dashboard.recentActivity",
    title: "Recent activity",
    content:
      "A running log of sends, signatures and completions across your account, newest first — a quick way to see what moved today.",
    placement: "bottom",
    when: canViewRequests,
  },
  {
    id: "dashboard-renewals",
    target: "dashboard.renewals",
    title: "Upcoming renewals",
    content:
      "Agreements coming up for renewal, grouped by month, so nothing lapses before you have had a chance to act on it.",
    placement: "bottom",
    when: canViewRenewables,
  },
  {
    id: "shell-inbox",
    target: "shell.inbox",
    title: "Your inbox",
    content:
      "Documents other people send you for signature arrive here. The badge counts the ones still waiting on you.",
    placement: "bottom",
    when: canViewRequests,
  },
];

export default dashboardSteps;
